import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import { toast } from "react-toastify";

const Logout = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    logout();
    toast.success("Logout successful!");
    window.location.href = '/login';
  }, [logout, navigate]);

  return null;
};

export default Logout;